import { Slider, alpha, useTheme } from '@mui/material'

const DateRangeSlider = ({
  value,
  max,
  onChange,
  formatLabel
}) => {
  const theme = useTheme()
  const primary = theme.palette.primary.main
  const trackH = 6

  return (
    <Slider
      value={value}
      valueLabelDisplay='auto'
      valueLabelFormat={formatLabel}
      onChange={onChange}
      min={0}
      max={max}
      step={1}
      marks
      color='primary'
      sx={{
        // Keep MUI content-box + default root height/padding so % positions for marks, rail,
        // track, and thumbs share one coordinate system (padding on root breaks alignment).
        width: '100%',
        maxWidth: '100%',
        // Mui adds marginBottom: 20 when marked — only for mark *labels* we don't use
        '&.MuiSlider-marked': { marginBottom: 0 },
        '& .MuiSlider-rail': {
          opacity: 1,
          height: trackH,
          borderRadius: trackH / 2,
          backgroundColor: alpha(primary, 0.22)
        },
        '& .MuiSlider-track': {
          height: trackH,
          borderRadius: trackH / 2,
          border: 'none',
          backgroundColor: primary
        },
        // Default mark transform assumes width 2px; slightly taller ticks, no width override
        '& .MuiSlider-mark': {
          height: 10,
          opacity: 0.45,
          backgroundColor: alpha(theme.palette.common.white, 0.5),
          '&.MuiSlider-markActive': {
            opacity: 1,
            backgroundColor: alpha(theme.palette.background.paper, 0.92)
          }
        },
        '& .MuiSlider-thumb': {
          width: 20,
          height: 20,
          '&::before': {
            boxShadow: `0 1px 4px ${alpha('#000', 0.45)}`
          },
          '&:hover, &.Mui-focusVisible': {
            boxShadow: `0 0 0 8px ${alpha(primary, 0.18)}`
          },
          '&.Mui-active': {
            boxShadow: `0 0 0 8px ${alpha(primary, 0.24)}`
          }
        }
      }}
    />
  )
}

export { DateRangeSlider }
